import { IncomeOrExpenseType } from 'further-types/lp/income-and-expenses';
import { NavigationRoute } from 'further-types/lp/ai-agent';
import {
  createIncomeOrExpenseAddRoute,
  createFundSetupRoute,
  createAccountingRoute,
  createOnboardingRoute,
  FundSetupTab,
  BankReconciliationTab,
  AccountingTab,
  OnboardingTab,
  INCOME_OR_EXPENSE_LIST,
  LP_INVESTMENT_CREATE,
  LP_INVESTMENT_LIST,
  LP_REALISATION_CREATE,
  LP_REALISATION_LIST,
  LP_CAPITAL_ACTION_CREATE,
  LP_CAPITAL_ACTION_LIST,
  LP_MANUAL_ACTION_CREATE,
  LP_MANUAL_ACTION_LIST,
  COMMITMENTS,
  ACCOUNTING,
  BANK_RECONCILIATION,
  FUND_SETUP,
  LP_FIRM_SETTINGS,
  VEHICLES,
  LP_COMPANY_LIST,
  LP_COMPANY_ADD,
  EQUALISATIONS,
  EQUALISATIONS_ADD,
  PARTNER_TRANSFERS_LIST,
  PARTNER_TRANSFERS_CREATE,
  LP_PERIOD_END_REVIEW,
  LP_ONBOARDING,
  FEE_MANAGER,
  USER_MANAGEMENT,
  LP_INVESTOR_UPDATES,
  PERIOD_END_REPORT_LIST,
} from 'adminConstants/routes';

export const resolveNavigationRoute = (route: NavigationRoute) => {
  switch (route) {
    case NavigationRoute.IncomeAdd:
      return createIncomeOrExpenseAddRoute(IncomeOrExpenseType.Income);
    case NavigationRoute.ExpenseAdd:
      return createIncomeOrExpenseAddRoute(IncomeOrExpenseType.Expense);
    case NavigationRoute.IncomeExpenseList:
      return INCOME_OR_EXPENSE_LIST;
    case NavigationRoute.InvestmentCreate:
      return LP_INVESTMENT_CREATE;
    case NavigationRoute.InvestmentList:
      return LP_INVESTMENT_LIST;
    case NavigationRoute.RealisationCreate:
      return LP_REALISATION_CREATE;
    case NavigationRoute.RealisationList:
      return LP_REALISATION_LIST;
    case NavigationRoute.CapitalActionCreate:
      return LP_CAPITAL_ACTION_CREATE;
    case NavigationRoute.CapitalActionList:
      return LP_CAPITAL_ACTION_LIST;
    case NavigationRoute.ManualJournalCreate:
      return LP_MANUAL_ACTION_CREATE;
    case NavigationRoute.ManualJournalList:
      return LP_MANUAL_ACTION_LIST;
    case NavigationRoute.Commitments:
      return COMMITMENTS;
    case NavigationRoute.Accounting:
      return ACCOUNTING;
    case NavigationRoute.AccountingGeneralLedger:
      return createAccountingRoute(AccountingTab.GeneralLedger);
    case NavigationRoute.AccountingTrialBalance:
      return createAccountingRoute(AccountingTab.TrialBalance);
    case NavigationRoute.AccountingBalanceSheet:
      return createAccountingRoute(AccountingTab.BalanceSheet);
    case NavigationRoute.AccountingIncomeStatement:
      return createAccountingRoute(AccountingTab.IncomeStatement);
    case NavigationRoute.AccountingCashFlowStatement:
      return createAccountingRoute(AccountingTab.CashFlowStatement);
    case NavigationRoute.AccountingScheduleOfInvestments:
      return createAccountingRoute(AccountingTab.ScheduleOfInvestments);
    case NavigationRoute.BankReconciliation:
      return BANK_RECONCILIATION;
    case NavigationRoute.BankReconciliationReconcile:
      return `${BANK_RECONCILIATION}${BankReconciliationTab.ReconcileTransactions}`;
    case NavigationRoute.BankReconciliationStatement:
      return `${BANK_RECONCILIATION}${BankReconciliationTab.BankStatement}`;
    case NavigationRoute.BankReconciliationReconciled:
      return `${BANK_RECONCILIATION}${BankReconciliationTab.ReconciledTransactions}`;
    case NavigationRoute.BankReconciliationAccountSettings:
      return `${BANK_RECONCILIATION}${BankReconciliationTab.AccountSettings}`;
    case NavigationRoute.FundSetup:
      return FUND_SETUP;
    case NavigationRoute.FundSetupGeneral:
      return createFundSetupRoute(FundSetupTab.FundSetup);
    case NavigationRoute.FundSetupChartOfAccounts:
      return createFundSetupRoute(FundSetupTab.ChartOfAccounts);
    case NavigationRoute.FundSetupAccountMapping:
      return createFundSetupRoute(FundSetupTab.AccountMapping);
    case NavigationRoute.FundSetupFeeSettings:
      return createFundSetupRoute(FundSetupTab.FeeSettings);
    case NavigationRoute.FundSetupCarrySettings:
      return createFundSetupRoute(FundSetupTab.CarrySettings);
    case NavigationRoute.FundSetupEqualisationInterest:
      return createFundSetupRoute(FundSetupTab.EqualisationInterest);
    case NavigationRoute.FirmSettings:
      return LP_FIRM_SETTINGS;
    case NavigationRoute.Vehicles:
      return VEHICLES;
    case NavigationRoute.HoldingsList:
      return LP_COMPANY_LIST;
    case NavigationRoute.HoldingsCreate:
      return LP_COMPANY_ADD;
    case NavigationRoute.Equalisations:
      return EQUALISATIONS;
    case NavigationRoute.EqualisationsAdd:
      return EQUALISATIONS_ADD;
    case NavigationRoute.PartnerTransfers:
      return PARTNER_TRANSFERS_LIST;
    case NavigationRoute.PartnerTransfersCreate:
      return PARTNER_TRANSFERS_CREATE;
    case NavigationRoute.PeriodEndReview:
      return LP_PERIOD_END_REVIEW;
    case NavigationRoute.Onboarding:
      return LP_ONBOARDING;
    case NavigationRoute.OnboardingOverview:
      return createOnboardingRoute(OnboardingTab.Overview);
    case NavigationRoute.OnboardingDocumentSigning:
      return createOnboardingRoute(OnboardingTab.DocumentSigning);
    case NavigationRoute.OnboardingSettings:
      return createOnboardingRoute(OnboardingTab.Settings);
    case NavigationRoute.FeeManager:
      return FEE_MANAGER;
    case NavigationRoute.UserManagement:
      return USER_MANAGEMENT;
    case NavigationRoute.InvestorUpdates:
      return LP_INVESTOR_UPDATES;
    case NavigationRoute.PeriodEndReport:
      return PERIOD_END_REPORT_LIST;
  }
};
